import * as React from 'react';
import { InlineText3 } from '@cian/ui-kit/typography';
import * as styles from './RequestDemandAgreements.css';

interface IRequestDemandAgreementsProps {
  buttonText: string;
}

const agreementLink = '/help/about/rules/';
const confidentialityLink = '/help/about/36526/';

export const RequestDemandAgreements: React.FC<IRequestDemandAgreementsProps> = ({ buttonText }) => {
  return (
    <InlineText3 color="black_60">
      Нажимая на кнопку «{buttonText}», вы принимаете условия{' '}
      <a className={styles['link']} href={agreementLink} target="_blank" rel="noreferrer">
        Пользовательского соглашения
      </a>{' '}
      и{' '}
      <a className={styles['link']} href={confidentialityLink} target="_blank" rel="noreferrer">
        Политики конфиденциальности
      </a>
    </InlineText3>
  );
};
